<template>
  <section class="purchase" @click="clickPurchaseFormAlign">
    <Step :active="active_index"></Step>
    <el-form label-position="right" label-width="120px" :hide-required-asterisk ='true' :model="purchaseFormAlign" :rules="rules"
      ref="purchaseFormAlign">
      <section class="purchaseinfo">
        <PurchaseTitle titlename="结算信息"></PurchaseTitle>
        <el-form-item label="结算方式">
          <el-radio-group v-model="purchaseFormAlign.payType" class="clear"
            @change="summount({ payType: purchaseFormAlign.payType })">
            <el-radio :label="0">按购券量结算（适用于固定预算）<img class="biaoqian" v-if="isShowSale" :src="imgbiaoqian" /><span
                v-if="isShowSale" class="activity">当前活动：买专快车券送专车券：单笔买50送20，买20送5，买10送1 <a target="_blank"
                  href="//es-static.xiaojukeji.com/static/web/home/jumpsalesh5TicketActive.html?__utm_source=daunnei_free_chuxingquanhoutai_gouquanguanli_kong_kong_chuxingquanhuodong_20181120_xianshang_liyanjiao_kong_kong">查看活动</a></span>
            </el-radio>
            <div 
              v-if="hasDiscount"
              v-bind:class = "discountInfo.payType == 1 ? 'discountIcon usecouponCount':'discountIcon '"
            >
              <span>限时特惠，单单{{discountInfo ? discountInfo.discount: '--'}}折</span>
              <!-- <a target="_blank" href="https://es.xiaojukeji.com/xpubpage?s=op-json-JKFoqKYeP">活动详情&gt;</a> -->
            </div>
            <p>无制券费，购买时按购买量结算。如：购买1000张100元面额专车券，则下单时直接结算100元/张*1000张=100000元的券费用。</p>
            <el-radio :label="1">按用券量结算（适用于大规模长期投放）</el-radio>
            <p>
              制券费1元/张，购买时结算制券费，冻结购券费，订单到期后按实际使用量结算。如：购买1000张100元面额专车券，则下单时结算1元/张*1000张=1000元的制券费，冻结100元/张*1000张=100000元的购券费，如果订单到期后，共使用了300张，则结算100元/张*300张=30000元的券费用，解冻100元/张*（1000-300）张=70000元的券费用到余额账户，用于下次购券。
            </p>
          </el-radio-group>
        </el-form-item>
        <PurchaseTitle titlename="券面信息"></PurchaseTitle>
        <el-form-item label="订单类型" v-if="selfGroup.isApi == 1">
          <el-radio-group v-model="purchaseFormAlign.channel" class="clear">
            <el-radio :label="3">线上（适用于左侧“发券管理”中直接发券）</el-radio>
            <el-radio :label="1">API（适用于接入API发券）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="券类型" class="quantype">
          <div class="pur_coupontype">
            <CouponTypeList :productId="purchaseFormAlign.productId" :isShowSale="isShowSale" />
          </div>
        </el-form-item>
        <el-form-item prop="couponAmount" ref="couponAmount">
          <template slot="label">
            单券面额
            <el-tooltip v-if="!1" class="item" effect="light" content="Top Left 提示文字" placement="right">
              <i class='el-icon-question'></i>
            </el-tooltip>
          </template>
          <el-radio-group v-model="currentAmount" @change="changeCouponAmount">
            <el-radio v-for="item in pricelist" :label="item" :key="item">{{ item }}</el-radio>
            <el-radio key='custom' :label='0'>
              自定义
              <el-input v-if="purchaseFormAlign.couponAmountType === 1" size="small" class="amountCustom"
                v-model="purchaseFormAlign.couponAmountCustom" @input="changeCouponAmountCustom" placeholder="10元以上整数">
              </el-input>
            </el-radio>
          </el-radio-group>
          <p v-if="previewPrice >= 50" class="warning">购劵提示：一张出行劵只能在一次订单中使用，不找零，不可叠加</p>
        </el-form-item>
        <el-form-item label="券文案" class="div-form-item">
          <!-- <section class="couponcardpreview">
            <span class="pretitle">券预览</span>
            <CouponCard
              :validity="(purchaseFormAlign.timedate && purchaseFormAlign.timedate.length && purchaseFormAlign.timedate[1]) || 'xxxx-xx-xx xx:xx:xx'"
              :price="previewPrice" :tip="purchaseFormAlign.couponExplain" :couponname="purchaseFormAlign.batchName"
              :coupontype="purchaseFormAlign.couponType" :width=335 :height=122 padding="15px 12px" nameSize="18px"
              priceSize="42px" status="1" />
          </section> -->
          <section v-if="!couponDocListLoading && !defaultCouponLoading && !orderInfoLoading">
            <coupon-document :callback="couponDocCallback" :couponName="purchaseFormAlign.batchName"
              :couponExplain="purchaseFormAlign.couponExplain" :couponTemplateId="purchaseFormAlign.couponTemplateId"
              :couponDocList="couponDocList" :defaultCoupon="defaultCoupon" />
          </section>
        </el-form-item>
        <el-form-item label="短信通知文案">
          <!-- <section class="couponcardpreview message-view">
            <span class="pretitle">短信预览</span>
            <div class="messagepreview">[出行券]尊敬的客户，<span>{{ purchaseFormAlign.smsCompanyName ?
                purchaseFormAlign.smsCompanyName : 'XXXX'
            }}</span>发送给您的出行券已放入您的滴滴出行-钱包中，使用滴滴出行APP或小程序叫车时可以自动抵扣支付。 退订TD
            </div> -->
            <!-- 链接失效先下掉 -->
            <!-- 点击链接即可叫车:http://dwz.cn/vnmzSO93 -->
          <!-- </section> -->
          <section v-if="!orderInfoLoading && !messageInfoListLoading">
            <message-info-document :callback="messageInfoCallback" :messageInfoList="messageInfoList"
              :messageInfoDoc="purchaseFormAlign.smsCompanyName" :smsTemplateId="purchaseFormAlign.smsTemplateId" />
          </section>
        </el-form-item>
        <PurchaseTitle titlename="有效期限"></PurchaseTitle>
        <el-form-item prop="timedate">
          <template slot="label">
            发券时间段
            <el-popover placement="top-start" title="" trigger="hover">
              <div>
                <p>出行券可以发放的时间范围，最长有效期100天</p>
                <p>例如：发券时间段为2018-05-01至2018-09-03，</p>
                <p>那么该批次的出行券仅支持2018-05-01至</p>
                <p>2018-09-03这个时间段内进行发放。</p>
              </div>
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>
          </template>
          <el-date-picker v-model="purchaseFormAlign.timedate" type="datetimerange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']" :picker-options="pickerOptions1">
          </el-date-picker>
          <div class="timepickerTips"  v-if="hasDiscount && checkIsinTime()">
            <span>开始时间在{{ getfotmatMoment(discountInfo.startTimeStr) }} ~ {{ getfotmatMoment(discountInfo.expireTimeStr) }}可参与{{discountInfo.discount}}折活动</span>
            <a target="_blank" href="https://es.xiaojukeji.com/xpubpage?s=op-json-JKFoqKYeP">活动详情&gt;</a>
          </div>
          <div class="timepickerTips"  v-else-if="hasDiscount && checkIsinDay()">
            <span>周期小于等于{{discountInfo.day}}天可参与{{discountInfo.discount}}折活动</span>
            <a target="_blank" href="https://es.xiaojukeji.com/xpubpage?s=op-json-JKFoqKYeP">活动详情&gt;</a>
          </div>
        </el-form-item>
        <el-form-item prop="expireDays" ref="expireDays">
          <template slot="label">
            券有效日期
            <el-tooltip v-if="!1" class="item" effect="light" content="Top Left 提示文字" placement="right">
              <i class='el-icon-question'></i>
            </el-tooltip>
          </template>
          <el-radio-group v-model="purchaseFormAlign.expire" class="clear" @change="changeexpire">
            <el-radio :label="0">与发券期限的截止日期相同</el-radio>
            <el-radio :label="1">发券后<el-input class="expireInput" :disabled="purchaseFormAlign.expireType === 0"
                v-model="purchaseFormAlign.expireDays"></el-input>天过期</el-radio>
          </el-radio-group>
        </el-form-item>
        <PurchaseTitle titlename="行程限制"></PurchaseTitle>
        <el-form-item label="使用地" prop="useAddress">
          <use-address :callback="UseAddressCallback" />
          <div class="el-form-item__error div-useAddress-error" v-if="useAddressValidMessage.length > 0">
            {{ useAddressValidMessage }}
          </div>
        </el-form-item>
        <PurchaseTitle titlename="购买信息"></PurchaseTitle>
        <el-form-item label="购券张数" prop="totalNumber">
          <el-input v-model="purchaseFormAlign.totalNumber" type="age" class="totalnumber" @input="totalchange">
          </el-input>张
          <p class="activity"
            v-if="isShowSale && purchaseFormAlign.payType === 0 && (purchaseFormAlign.productId === 200 || purchaseFormAlign.productId === 210)">
            <span class="ac_tip"><img :src="imgactivity" />买专快车券送专车券：单笔买50送20，买20送5，买10送1</span> <a target="_blank"
              href="//es-static.xiaojukeji.com/static/web/home/jumpsalesh5TicketActive.html?__utm_source=daunnei_free_chuxingquanhoutai_gouquanguanli_kong_kong_chuxingquanhuodong_20181120_xianshang_liyanjiao_kong_kong">查看活动</a>
          </p>
        </el-form-item>
        <el-form-item label="发券总金额" class="amount">
          <span>{{ purchaseFormAlign.totalCouponAmount }}元</span>
        </el-form-item>
        <el-form-item label="制券服务费" class="amount">
          <span>{{ purchaseFormAlign.serviceAmount }}元</span>
          <p v-if="purchaseFormAlign.payType === 0">按使用量结算要收取制券服务费</p>
        </el-form-item>
        <el-form-item label="折扣" class="discountAmount" v-if="purchaseFormAlign.discountAmount > 0">
          <span>-{{purchaseFormAlign.discountAmount}}</span>元
        </el-form-item>
        <el-form-item label="总金额" class="totalamount">
          <span>{{ purchaseFormAlign.totalCouponAmount + purchaseFormAlign.serviceAmount - purchaseFormAlign.discountAmount }}</span>元
        </el-form-item>
      </section>      
    </el-form>
    <div class="bot">
      <el-button :disabled="purchaseDisabled" type="primary" @click="goPay">确认购买</el-button>
    </div>
    <CouponGuide v-if="initGuideDialog"></CouponGuide>
  </section>
</template>
<script>
import { mapState, mapActions } from 'vuex'

import PurchaseTitle from './components/title.vue'
import Step from './components/step.vue'
import CouponGuide from './components/CouponGuide.vue'
import CouponTypeList from './components/CouponTypeList.vue'
import CouponCard from 'Components/CouponCard.vue'
import UseAddress from './components/UseAddress.vue'
import CouponDocument from './components/CouponDocument.vue'
import MessageInfoDocument from './components/MessageInfoDocument.vue'
import PuchaseBorder from './components/border.vue'
import ImgBiaoqian from 'Images/img_biaoqian2.png'
import ImgActivity from 'Images/ic_1.png'

import lodash from 'lodash'
import moment from 'moment'
let checkAmount = (value) => {
  const minAmount = 10, maxAmount = 2000;
  if (value == '') {
    return '自定义面额不能为空'
  }
  if (isNaN(Number(value))) {
    return '自定义面额必须为整数'
  }
  if (!/^[1-9]\d*$/.test(value)) {
    return '自定义面额必须为整数'
  }
  if (value < minAmount) {
    return '自定义面额不能小于10'
  }
  if (value > maxAmount) {
    return '自定义面额不能超过2000'
  }
  return '自定义面额须为整数'
}
export default {
  components: {
    PurchaseTitle,
    Step,
    CouponCard,
    CouponTypeList,
    UseAddress,
    CouponDocument,
    MessageInfoDocument,
    PuchaseBorder,
    CouponGuide
  },
  computed: {
    ...mapState('purchase', {
      messageInfoList: 'messageInfoList',
      defaultCoupon: 'defaultCoupon',
      couponDocList: 'couponDocList',
      purchaseFormAlign: 'orderInfo',
      allAriceList: 'allAriceList',
      pricelist: 'pricelist',
      useAddressData: 'useAddressData',
      PurchaseSuccess: 'PurchaseSuccess',
      couponDocListLoading: 'couponDocListLoading',
      defaultCouponLoading: 'defaultCouponLoading',
      orderInfoLoading: 'orderInfoLoading',
      messageInfoListLoading: 'messageInfoListLoading'
    }),
    ...mapState('header', ['userInfo', 'selfGroup','hasDiscount','discountInfo']),
    previewPrice: function () {
      const { couponAmountCustom, couponAmount, couponAmountType } = this.purchaseFormAlign
      let price = '--'
      if (couponAmountType === 1) {
        if (!isNaN(Number(couponAmountCustom)) && /^[1-9]\d*$/.test(couponAmountCustom) && couponAmountCustom >= 10 && couponAmountCustom <= 2000) {
          price = couponAmountCustom
        }
      } else {
        price = couponAmount
      }
      return price
    },
    currentAmount: {
      get: function () {
        const { couponAmountCustom, couponAmount, couponAmountType } = this.purchaseFormAlign
        if (couponAmountType === 1) {
          return 0
        } else {
          return couponAmount
        }
      },
      set: function (value) {
        // console.log(value)
        this.purchaseFormAlign.couponAmount = value
        if (value === 0) {
          this.purchaseFormAlign.couponAmountType = 1
        } else {
          this.purchaseFormAlign.couponAmountType = 0
        }
      }
    }
  },
  data() {
    let checkcouponAmount = (rule, value, callback) => {
      if (value === 0) {
        callback()
      } else {
        if (Number(value) > 0) {
          callback()
        } else {
          callback(new Error('请选择券面额'))
        }
      }
    }
    let checkdate = (rule, value, callback) => {
      // let payType = this.purchaseFormAlign.payType
      if (value && value.length === 2) {
        let endDateStr = value[1]
        let startDateStr = value[0]
        let endDate = new Date(endDateStr)
        let startDate = new Date(startDateStr)
        let endDateValue = endDate.valueOf()
        if (endDateValue < new Date().valueOf()) {
          callback(new Error('结束日期应在当前日期之后'))
          return
        }
        // if (payType === 1) {
        //   let endDate30DaysAgo = endDate.setDate(endDate.getDate() - 30)
        //   if (startDate.valueOf() < endDate30DaysAgo.valueOf()) {
        //     callback(new Error('按用券量结算时，发券期限范围必须在30天之内'))
        //   }
        // } else {
        let endDate100DaysAgo = endDate.setDate(endDate.getDate() - 100)
        if (startDate.valueOf() < endDate100DaysAgo.valueOf()) {
          callback(new Error('发券期限范围必须在100天之内'))
        }
        // }
        callback()
      } else {
        callback(new Error('请选择发券期限'))
      }
    }

    let checkTotalNumber = (rule, value, callback) => {
      if (/\.+/.test(value)) {
        callback(new Error('请输入正整数'))
        return
      }
      if (isNaN(value)) {
        callback(new Error('请输入正整数'))
        return
      }
      let totalNumber = Number(value)
      if (!Number.isInteger(totalNumber)) {
        callback(new Error('请输入正整数'))
      } else if (totalNumber <= 0) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    }

    let checkexpireDays = (rule, value, callback) => {
      if (this.purchaseFormAlign.expireType !== 0 && value.length === 0) {
        callback(new Error('请输入过期天数'))
        return
      }
      if (this.purchaseFormAlign.expireType !== 0 && !Number(value) > 0) {
        callback(new Error('请输入数字'))
      } else if (value < 0) {
        callback(new Error('请输入正整数'))
      } else if (value > 30) {
        callback(new Error('不能超过30天'))
      } else {
        callback()
      }
    }

    let checkBatchNameIlegal = (rule, value, callback) => {
      this.checkIllegal(rule, value, callback, 13, '券名称最多13个字符')
    }

    let checkCouponExplainIlegal = (rule, value, callback) => {
      // let reg = /[`~!@#$%^&*()-+<>?:"{},./;'[\]￥《》{}-——|、【】（）/\\"”“；。，]/im
      this.checkIllegal(rule, value, callback, 20, '券说明最多20个字符')
    }

    let checkSmsCompanyNameIlegal = (rule, value, callback) => {
      // let reg = /[`~!@#$%^&*()-+<>?:"{},./;'[\]￥《》{}-——|、【】（）/\\"”“；。，]/im
      this.checkIllegal(rule, value, callback, 20, '短信通知文案最多20个字符')
    }

    return {
      isShowSale: moment().isBefore('2018-12-31 23:59:59'),
      active_index: 0,
      imgbiaoqian: ImgBiaoqian,
      imgactivity: ImgActivity,
      rules: {
        timedate: [
          { validator: checkdate, trigger: 'change' }
        ],
        couponAmount: [
          { validator: checkcouponAmount, trigger: 'change', required: true },
        ],
        expireDays: [
          { validator: checkexpireDays, trigger: 'blur' },
          { validator: checkexpireDays, trigger: 'change' }
        ],
        batchName: [
          { required: true, message: '请输入券名称', trigger: 'change' },
          { validator: checkBatchNameIlegal, trigger: 'change' }
        ],
        couponExplain: [
          { required: true, message: '请输入券说明', trigger: 'change' },
          { validator: checkCouponExplainIlegal, trigger: 'change' }
        ],
        smsCompanyName: [
          { required: true, message: '请输入短信通知文案', trigger: 'change' },
          { validator: checkSmsCompanyNameIlegal, trigger: 'change' }
        ],
        totalNumber: [
          { validator: checkTotalNumber, trigger: 'change', required: true }
        ],
      },
      useAddressValidMessage: '',
      purchaseDisabled: false,
      pickerOptions1: {
        disabledDate: function (time) {
          const today = new Date()
          let year = today.getFullYear()
          let month = today.getMonth() + 1
          let day = today.getDate()
          month = month < 10 ? `0${month}` : month
          day = day < 10 ? `0${day}` : day

          let date = `${year}-${month}-${day} 00:00:00`

          return time.getTime() < new Date(date).getTime()
        }
      },
      newOrNot: true,
      initGuideDialog:false
    }
  },
  watch: {
    PurchaseSuccess(val) {
      if (val) {
        this.purchaseDisabled = false
        let self = this
        if (val.status === 0) {
          self.$message({
            message: '购券成功',
            type: 'success',
            duration: '1000',
            onClose: function () {
              self.$router.push({ path: 'pay', query: { orderId: val.data } }).catch(err => { })
            }
          })
        } else {
          self.$message.error('购券失败')
        }
      }else{
        this.purchaseDisabled = false
      }
    },
    'purchaseFormAlign.timedate'(val) {
      if (val && val.length > 0) {
        this.purchaseFormAlign.startTime = val[0]
        this.purchaseFormAlign.expireTime = val[1]
        this.doSummount()
      }
    },
    'purchaseFormAlign.expireDays'(val) {
      if (this.purchaseFormAlign.expireType !== 0) {
        this.purchaseFormAlign.expireType = val
      }
    },
    'purchaseFormAlign.productId': function (val, oldVal) {
      // console.log(val, oldVal)
      if (val !== oldVal) {
        //   console.log('qinkong,e')
        this.purchaseFormAlign.couponAmountCustom = ''
        if (oldVal !== '') {
          this.purchaseFormAlign.serviceAmount = 0, // 制券费
          this.purchaseFormAlign.totalCouponAmount = 0 // 券总金额	
          this.summount()
        } else {

        }
      }
    },
  },
  methods: {
    // ...mapMutations('header', ['SET_GROUP']),
    ...mapActions('purchase', [
      'getMessageList',
      'getCouponDocList',
      'getDefaultCoupon',
      'getAmount',
      'getOrderInfoForCopy',
      'getOrderInfoForEdit',
      'purchaseCoupon',
      'getPriceList'
    ]),
    ...mapActions('header', ['getDiscount']),
    checkIllegal(rule, value, callback, length, message) {
      if (/^[ ]+$/.test(value)) {
        callback(new Error('您的输入含有非法字符'))
        return
      }
      value = value.trim()
      if (value.length > length) {
        callback(new Error(message))
      } else {
        callback()
      }
    },
    couponDocCallback({ couponName, couponExplain, couponId }) {
      this.purchaseFormAlign.batchName = couponName
      this.purchaseFormAlign.couponExplain = couponExplain
      this.purchaseFormAlign.couponTemplateId = (couponId && couponId !== 0) ? couponId : ''
    },
    messageInfoCallback({ messageInfoDoc, messageInfoChooseId }) {
      this.purchaseFormAlign.smsCompanyName = messageInfoDoc
      this.purchaseFormAlign.smsTemplateId = (messageInfoChooseId && messageInfoChooseId !== 0) ? messageInfoChooseId : ''
    },
    UseAddressCallback(v) {
      // console.log(v)
      let { addressRadio, city, startFence, endFence, fenceType } = v
      this.validUseAddress(addressRadio, city, startFence, endFence, fenceType)
      Object.assign(this.purchaseFormAlign, v)
    },
    getfotmatMoment(timeStr){
      return moment(timeStr).format("MM.DD")
    },
    checkIsinTime(){
      let {startTimeStr,expireTimeStr} = this.discountInfo
      if(moment(this.purchaseFormAlign.startTime).isSameOrBefore(expireTimeStr) && moment(this.purchaseFormAlign.startTime).isSameOrAfter(startTimeStr)){
        return false
      }else{
        return true
      }
    },
    checkIsinDay(){
      let {day} = this.discountInfo
      if(moment(this.purchaseFormAlign.expireTime).diff(moment(this.purchaseFormAlign.startTime), 'days')  <= day){
        return false
      }else{
        return true
      }
    },
    /**
     * 验证 useAddress 是否校验合格
     */
    validUseAddress(addressRadio, city, startFence, endFence, fenceType) {
      let validate = true
      if (addressRadio === '3') {
        if (fenceType === '1' || fenceType === '4') {
          if (startFence.length === 0 && endFence.length === 0) {
            this.useAddressValidMessage = '请填写出发地和目的地'
            validate = false
          } else if (startFence.length === 0) {
            this.useAddressValidMessage = '请填写出发地'
            validate = false
          } else if (endFence.length === 0) {
            this.useAddressValidMessage = '请填写目的地'
            validate = false
          } else if (startFence.split(',').length > 3) {
            this.useAddressValidMessage = '出发地最多选择3个'
            validate = false
          } else if (endFence.split(',').length > 3) {
            this.useAddressValidMessage = '目的地最多选择3个'
            validate = false
          }
        } else if (fenceType === '2') {
          if (startFence.length === 0) {
            this.useAddressValidMessage = '请填写出发地'
            validate = false
          } else if (startFence.split(',').length > 3) {
            this.useAddressValidMessage = '出发地最多选择3个'
            validate = false
          }
        } else if (fenceType === '3') {
          if (endFence.length === 0) {
            this.useAddressValidMessage = '请填写目的地'
            validate = false
          } else if (endFence.split(',').length > 3) {
            this.useAddressValidMessage = '目的地最多选择3个'
            validate = false
          }
        }
      } else if (addressRadio === '2') {
        // 没选城市
        if (city === 0) {
          this.useAddressValidMessage = '请选择城市'
          validate = false
        }
      }
      if (validate) {
        this.useAddressValidMessage = ''
      }
      return validate
    },
    totalchange: lodash.debounce(function (value) { // total值改变时
      // lodash 自带的函数防抖
      if (!value) {
        return
      }
      if (Number(value) >= 0) {
        this.summount()
      }
    }, 400),
    doSummount(){
      this.purchaseFormAlign.discountAmount = 0 //折扣
      this.purchaseFormAlign.serviceAmount = 0, // 制券费
      this.purchaseFormAlign.totalCouponAmount = 0 // 券总金额	
      this.summount()
    },
    changeexpire(value) {
      if (value === 1) {
        this.purchaseFormAlign.expireType = this.purchaseFormAlign.expireDays
      } else {
        this.purchaseFormAlign.expireType = 0
        // 清除验证
        this.$refs['expireDays'].clearValidate()
      }
    },
    changeCouponAmount(value) {
      if (value === 0) {

        this.$refs['couponAmount'].clearValidate()
        if (this.purchaseFormAlign.couponAmountCustom !== '') {
          this.changeCouponAmountCustom(this.purchaseFormAlign.couponAmountCustom)
        } else {
          this.purchaseFormAlign.serviceAmount = 0, // 制券费
            this.purchaseFormAlign.totalCouponAmount = 0 // 券总金额	
        }
      } else {
        // this.purchaseFormAlign.couponAmountType = 0
        this.summount()
      }
    },
    changeCouponAmountCustom: lodash.debounce(function (value) {
      this.$refs['couponAmount'].clearValidate()
      if (!isNaN(Number(value)) && /^[1-9]\d*$/.test(value) && value >= 10 && value <= 2000) {
        this.purchaseFormAlign.couponAmountCustom = Number(this.purchaseFormAlign.couponAmountCustom)
        this.summount()
      } else {
        // console.log(`this.$refs['couponAmount']`,this.$refs['couponAmount'])
        this.purchaseFormAlign.serviceAmount = 0, // 制券费
          this.purchaseFormAlign.totalCouponAmount = 0 // 券总金额	
        this.$refs['couponAmount'].validateState = 'error'
        this.$refs['couponAmount'].validateMessage = checkAmount(value)
      }
    }, 400),
    debounce(func, delay) {
      let timer

      return function (...args) {
        if (timer) {
          clearTimeout(timer)
        }
        timer = setTimeout(() => {
          func.apply(this, args)
        }, delay)
      }
    },
    // resetTimer () {
    //   clearInterval(timer)
    //   timer = setInterval(this.getDatas, interval)
    // },
    summount() {
      //重置前 先隐藏折扣信息
      this.purchaseFormAlign.discountAmount = 0
      let { couponAmount, productId, totalNumber, payType, couponAmountCustom, couponAmountType ,startTime ,expireTime} = this.purchaseFormAlign
      if (/\.+/.test(totalNumber) || isNaN(totalNumber)) {
        return
      }
      if (couponAmountType === 1) {
        if (isNaN(Number(couponAmountCustom)) || !/^[1-9]\d*$/.test(couponAmountCustom) || couponAmountCustom < 10 || couponAmountCustom > 2000) {
          return
        }
      }
      if (Number(couponAmount) >= 0 && productId && Number(totalNumber) >= 0 && totalNumber) {
        let amount = couponAmountType === 1 ? couponAmountCustom : couponAmount
        let paramsObj = { 
          couponAmount: amount, 
          productId, 
          totalNumber, 
          payType,
        }
        // debugger
        if(this.hasDiscount){
          let {day,startTimeStr,expireTimeStr,id} = this.discountInfo  
          if(this.discountInfo.payType == payType  &&  moment(startTime).isSameOrBefore(expireTimeStr) && moment(startTime).isSameOrAfter(startTimeStr) && moment(expireTime).diff(moment(startTime), 'days')  <= day){
            // 判断是否符合优惠条件
            paramsObj = Object.assign({},paramsObj,{
              discountId:id,
              startTime,
              expireTime
            })
          }
        }
        this.getAmount(paramsObj)
        // this.debounce(({ price, productId, totalNumber, payType }) => {
        //   this.getAmount({ price, productId, totalNumber, payType })
        // }, 200)
      }
    },
    goPay() {
      this.$refs['purchaseFormAlign'].validate((valid, obj) => {
        let { addressRadio, city, startFence, endFence, fenceType, couponAmountCustom, couponAmount, couponAmountType ,payType,startTime ,expireTime} = this.purchaseFormAlign
        //手动验证券面额
        if (couponAmountType === 1) {
          if (isNaN(Number(couponAmountCustom)) || !/^[1-9]\d*$/.test(couponAmountCustom) || couponAmountCustom < 10 || couponAmountCustom > 2000) {
            this.$refs['couponAmount'].validateState = 'error'
            this.$refs['couponAmount'].validateMessage = checkAmount(couponAmountCustom)
            this.$message({
              type: 'warning',
              message: checkAmount(couponAmountCustom)
            })
            return false
          }
        }
        let useAddressValid = this.validUseAddress(addressRadio, city, startFence, endFence, fenceType)
        if (useAddressValid && valid) {
          this.omgTrack('es_chuxingquan_xieyi_buy_ck', '出行券模块点击提交购买')
          // 清理传入的无用参数
          this.purchaseFormAlign.startFenceList = []
          this.purchaseFormAlign.endFenceList = []
          // 去掉首尾空格
          this.purchaseFormAlign.batchName = this.purchaseFormAlign.batchName.trim()
          this.purchaseFormAlign.couponExplain = this.purchaseFormAlign.couponExplain.trim()
          this.purchaseFormAlign.smsCompanyName = this.purchaseFormAlign.smsCompanyName.trim()
          this.purchaseFormAlign.couponAmount = couponAmountType === 1 ? couponAmountCustom : couponAmount
          //添加字段
          this.purchaseFormAlign.couponAmountStr = this.purchaseFormAlign.couponAmount
          //判断是否有折扣// 判断是否符合优惠条件
          
          if(this.hasDiscount){
            let {day,startTimeStr,expireTimeStr,id} = this.discountInfo
            if(this.discountInfo.payType == payType  &&  moment(startTime).isSameOrBefore(expireTimeStr) &&  moment(startTime).isSameOrAfter(startTimeStr) && moment(expireTime).diff(moment(startTime), 'days')  <= day){
                this.purchaseFormAlign.discountId = id 
            }
          }
          
          this.purchaseCoupon(this.purchaseFormAlign)
          // 禁用购买 Button 防止点两次
          this.disableButton()
        } else {
          let warnmessage = obj[Object.keys(obj)[0]][0].message || '购券信息未填写完整'
          this.$message({
            type: 'warning',
            message: warnmessage
          })
          return false
        }
      })
    },
    disableButton() {
      this.purchaseDisabled = true
      setTimeout(() => {
        this.purchaseDisabled = false
      }, 10000)
    },
    clickPurchaseFormAlign() {
      //   console.log(this.purchaseFormAlign)
    }
  },
  beforeMount: function () {
    let { orderId, sourcetype } = this.$route.query
    if (sourcetype === 'edit') {
      this.getOrderInfoForEdit({ orderId: orderId })
      this.newOrNot = false
      this.initGuideDialog = false 
    } else if (sourcetype === 'copy') {
      this.getOrderInfoForCopy({ orderId: orderId })
      this.newOrNot = false
      this.initGuideDialog = false 
    } else {
      this.newOrNot = true
      this.initGuideDialog = true 
    }
    //获取折扣
    this.getDiscount()
  },
  mounted: function () {
    this.getMessageList()
    this.getCouponDocList()
    this.getDefaultCoupon()
    this.getPriceList({ productId: '200,181,120,210,20' })
    // console.log('purchaseFormAlign',this.purchaseFormAlign)
    this.omgTrack('es_chuxingquan_xieyi_buy_manage_sw', '出行券模块打开购券管理页面')
    console.log("userInfo", this.userInfo, this.selfGroup)
  },
  beforeDestroy: function () {
    this.$store.commit('purchase/RESET_PURCHASESUCCESS', { response: false })
    let data = {
      useAddressData: 'useAddressData',
      orderInfo: 'orderInfo'
    }
    this.$store.dispatch('purchase/initState', data)
  }
}
</script>

<style lang="stylus">
    .purchase{
      .biaoqian{
        height: 20px;
        vertical-align: sub;
        margin-right: 20px;
      }
      .item{
          margin-top: inherit;
          margin-left: inherit;
      }
      margin-left: 20px
      padding-bottom: 30px
      .el-tabs__nav-wrap::after{
          display: none;
      }
      .el-tabs__active-bar{
          display: none;
      }
      .el-form-item.is-success .el-input__inner, .el-form-item.is-success .el-input__inner:focus, .el-form-item.is-success .el-textarea__inner, .el-form-item.is-success .el-textarea__inner:focus{
          border-color: #3468FF;
      }
      .el-tabs__item{
          border: 1px solid #CCCCCC;
          line-height: initial;
          padding: 10px !important;
          width: 180px;
          text-align: center;
      }
      .el-tabs__item.is-active{
          color: #409EFF;
          border: solid #409EFF 1px;
      }
      .div-form-item .el-tabs__content .el-form-item__content{
          display: inline-block;
      }
      .expireInput {
          width: 150px;
          margin-left:10px;
          margin-right:10px;
      }
      .timepickerTips{
        position:absolute;
        left: 412px;
        top: -1px;
        span{
          font-family: PingFangSC-Regular;
          font-size: 12px;
          font-weight: normal;
          line-height: 14px;
          letter-spacing: 0px;
          color: #fff;
          background: linear-gradient(108deg, #ff975c 3%, #f00 100%);
          border-radius: 4px 4px 4px 0px;
          line-height: 16px; 
          padding: 2px 4px;
        }
        a{
          font-family: PingFangSC-Regular;
          font-size: 12px;
          font-weight: normal;
          line-height: 14px;
          letter-spacing: 0px;
          color: #999;
          margin-left: 10px;
          text-decoration: none;

        }
      }
      .clear{
        postion:relative;
          .discountIcon{
              position: absolute;
							left: 232px;
              top: 9px;
              span{
                padding: 2px 4px;
                width: initial;
                height: 16px;
                opacity: 1;
                display: inline-block;
                border: none;
                background: linear-gradient(108deg, #ff975c 3%, #f00 100%);
                /* font-family: PingFangSC-Medium; */
                font-size: 10px;
                font-weight: normal;
                line-height: 16px;
                letter-spacing: 0px;
                color: #fff;
                text-align: center;
                border-radius: 4px 4px 4px 0px;
              }
              a{
                font-family: PingFangSC-Regular;
                font-size: 12px;
                font-weight: normal;
                line-height: 14px;
                letter-spacing: 0px;
                color: #999;
                margin-left: 10px;
                text-decoration: none;

              }
						}
          .usecouponCount{
            top: 74px;
            left: 277px;
          }
          .el-radio{
              display: block
              line-height: 40px
              margin-left : 0px
          }
          p{
              line-height: 25px
              width: 70%
              color: #999
              font-size: 12px
              margin-left: 24px
          }

      }
      .activity{
        color: #FC6F53;
        font-size 14px
        .ac_tip{
          img{
            height:10px;
            display: block;
            margin-top: 12px;
            margin-right: 5px;
          }
          height: 34px;
          padding-left:10px;
          padding-right:20px;
          display: inline-flex;
          background : #FC6F53;
          color: #fff;
          font-size:12px;
          line-height: 34px;
        }
        a{
          color #3468FF
          text-decoration none
          margin-left 10px
        }
      }
      .purchaseinfo{
          padding-right: 16px;
          .couponcardpreview{
              float: right
              width 351px
              height 175px
              background: #F3F4F5
              border-radius: 4px
              font-size 12px
              color: #999
              padding-left:16px
              // margin-right: 63px
              adding-bottom: 16px
              .card_container{
                  margin-top: -8px
              }
          }
          .pur_coupontype{
              margin-right 330px

          }
          .messagepreview{
              background: #FFFFFF;
              border-radius: 4px;
              line-height: 24px;
              margin-right: 16px;
              color: #333333
              padding:16px;
              span{
                  color:#FC6F53;
              }
          }
          .totalnumber{
              width 135px;
              margin-right: 10px;
          }
          .amount{
            margin-bottom:8px;
              span{
                  font-size: 18px;
                  color: #333333;
              }
              p{
                  font-size: 14px;
                  color: #999999;
              }
          }
          .discountAmount{
            color: #FF8252;
            span{
                  font-size: 18px;
                  
              }
          }
          .totalamount{
              color: #FF8252;
              span{
                  font-size: 28px;
              }
          }
          .amountCustom{
            margin-left:10px;
            width:120px;
          }
          .warning{
            color:#999;
            font-size:12px;
          }
      }
      .bot{
          padding-top: 16px;
          background-color: #fff;
          z-index: 100;
          padding-left: 151px;
          box-shadow: 0 -5px 15px 0 hsla(0,1%,65%,.15);
          position: fixed;
          bottom: 0;
          width: 100%;
          height: 64px;
          margin-left:-30px;
      }
      label[for='useAddress']:before {
          content: '*';
          color: #f56c6c;
          margin-right: 4px;
      }
      .el-tabs__item.is-active {
        color: #3468ff;
        border: solid #3468ff 1px;
      }
      .coupontype p {
        line-height: 12px;
      }
      .purchaseinfo .message-view {
        padding-bottom: 16px;
      }
      .div-useAddress-error {
        padding-top: 0;
        position: initial;
        padding-bottom: 6px;
        line-height: 0;
      }
    }
</style>
